import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el Kit después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. Todo en PDF.'
  }, {
    q: '¿Sirve para todos los niveles de alumnos?',
    a: 'Sí, desde nivel inicial (cero) hasta intermedio/avanzado.'
  }, {
    q: '¿Es editable?',
    a: 'El material viene en PDF. La planificación anual incluye formato editable.'
  }, {
    q: '¿Los 4 bonos están incluidos en ambas ofertas?',
    a: 'Sí, tanto el Kit Básico como el Pack Pro incluyen los 4 bonos.'
  }, {
    q: '¿Puedo comprar el Kit básico y después actualizar?',
    a: 'Sí, pero recomendamos el Pack Pro desde el inicio por el valor que aporta.'
  }, {
    q: '¿Funciona para clases particulares y grupales?',
    a: 'Totalmente. Se adapta a ambos formatos.'
  }, {
    q: '¿Sirve para alumnos que nunca tocaron?',
    a: 'Sí, el Tomo 1 está diseñado para arrancar desde cero absoluto.'
  }, {
    q: '¿Está organizado por nivel?',
    a: 'Sí, todo tiene progresión lógica y pedagógica.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, 7 días de garantía de satisfacción total.'
  }, {
    q: '¿Qué diferencia tiene con otros materiales?',
    a: 'No son partituras sueltas. Es un sistema pedagógico completo.'
  }];
  return <section className="bg-[#0a1128] py-4 md:py-6 px-3 border-t border-[#1e293b]" data-id="element-32">
      <div className="max-w-2xl mx-auto" data-id="element-33">
        <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-4" data-id="element-34">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-1.5" data-id="element-35">
          {faqs.map((faq, i) => <div key={i} className="bg-[#050a1a] border border-[#1e293b] rounded-lg overflow-hidden" data-id="element-36">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-2.5 text-left" data-id="element-37">
                <span className="font-bold text-white text-xs md:text-sm pr-3" data-id="element-38">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} data-id="element-39">
                  <ChevronDown className="w-4 h-4 text-[#2563eb] flex-shrink-0" data-id="element-40" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-41">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-42">
                    <div className="px-2.5 pb-2.5 text-gray-400 text-xs border-t border-[#1e293b] pt-2" data-id="element-43">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}